import { Price } from '@util/Currency';
import { Alert } from 'antd';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { useAppStore } from '../../../store/Store';
import { PricingSelector } from '../../../store/pricing/PricingActions';

export const Coupon: FunctionComponent = () => {
  const { percentOff, amountOff, currency } = useAppStore((state) => ({
    percentOff: Math.floor(PricingSelector.percentRatioOff(state.pricing) * 100),
    amountOff: PricingSelector.amountOff(state.pricing),
    currency: state.pricing.currency,
  }));
  const hasDiscount = percentOff > 0 || amountOff > 0;
  const discount =
    percentOff > 0 ? `${percentOff}%` : Price.formatWithCurrency(amountOff, currency);

  return hasDiscount ? <CouponAlert message={`${discount} discount applied!`} /> : null;
};

const CouponAlert = styled(Alert).attrs({
  'data-test': 'couponAlert',
  type: 'success',
  showIcon: true,
  closable: true,
})`
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: 0px;
`;
